import { ReactElement, useEffect, useState } from 'react';
import WalletInfo from './WalletInfo';
import Wallet from '@/components/wallet';
import { useAppDispatch, useWallet } from '@/services';
import styles from '@/styles/components/wallet-menu.module.less';
import { SupportChains } from '@/config';
import ContractConstants from '@/services/contract.constants';
import { loadTokenInfo } from '@/services/reducers/token';
import SandboxPoster from '@/framework/events/SandboxPoster';
import { useConnectWallet } from '@web3-onboard/react';
const WalletMenu = (): ReactElement => {
    const [visible, setVisible] = useState(false);
    const { connected, chainId } = useWallet();
    const __dispatch = useAppDispatch();
    useEffect(() => setVisible(false), [connected]);
    const [, connect] = useConnectWallet();

    useEffect(() => {
        const chain = SupportChains.filter((o) => o.chainId == chainId)[0];
        if (!chain) return;
        __dispatch(loadTokenInfo(ContractConstants.Names.AGDToken));
        __dispatch(loadTokenInfo(ContractConstants.Names.AGSToken));
        SandboxPoster.Post('Wallet.SwitchChain', chain);
    }, [chainId]);
    return (
        <div className={styles['wallet-menu']}>
            <WalletInfo toLink={() => connect()} />
            <Wallet visible={visible} hide={() => setVisible(false)} />
        </div>
    );
};

export default WalletMenu;
